(function () {
    /* jshint validthis: true */
    "use strict";

    PAGE_HASH = PAGE_HASH || window.location.hash;

    var lang = lang || document.documentElement.lang;
    var langs = langs || document.documentElement.getAttribute("langs");

    function setUid(el, i) {
        el.setAttribute("data-uid", randomIdLetter());
    }

    //Menu Selection Component
    //Triggers the opening of the description of a category
    //Simply adds a selected class on the container (and removes the one already in selection)
    function openCategorySelection() {
        var t = $(this);
        var ctn = t.closest(".menus-selection");

        $(".category-selection.selected", ctn).removeClass("selected");
        t.closest(".category-selection").addClass("selected");
    }

    //For admin : determines if a selection is visible by users
    //Sets a double-click label (true / false) and adds or remove a class on the SVG
    function toggleSelectionVisibility() {
        var t = $(this);
        var label = t.attr("data-label");
        var visible = !t.hasClass("not-visible");

        var _update = function () {
            if (!visible) {
                t.removeClass("not-visible");
            } else {
                t.addClass("not-visible");
            }
        };

        updateLabelLangs(label, !visible, langs, _update, true);
    }

    //For admin : switches position of img / txt
    //Sets a double-click label (true / false) and adds or remove a class on the component
    function toggleCompPosition() {
        var t = $(this);
        var textId = t.closest(".stool-radio").attr("data-textId");
        var label = t.closest(".stool-radio").attr("data-label");

        var cl = "txt-img-wrap-" + textId;

        var position = t.val() === 'true';
        var reversed = $("." + cl).hasClass("reversed-txt-img");

        var _update = function () {
            if (!reversed && position) {
                $("." + cl).addClass("reversed-txt-img");
            } else if (reversed && !position) {
                $("." + cl).removeClass("reversed-txt-img");
            }
        };

        updateLabelLangs(label, position, langs, _update, true);
    }

    function switchComponentVersion(e) {
        var it = e ? e.currentTarget : this;
        var ctn = getAncestor(it, "component-settings-version-ctn");
        
        updateLabelLangs(ctn.getAttribute("data-label"), it.value, langs, function(response) {
            var comEl = document.getElementById(ctn.getAttribute("data-component-id"));
            var curCls = "v" + ctn.getAttribute("data-value");

            if (it.value !== ctn.getAttribute("data-value")) {
                removeClass(comEl, curCls);
            }
            if (it.value !== "") {
                addClass(comEl, "v" + it.value);
            }
            ctn.setAttribute("data-value", it.value);
        }, true);
    }
    
    //Switches between different panel in the gallery component
    function toggleGalleryVisibility(){
        var t = $(this);
        var type = t.attr("data-type");
        var ctn = t.closest(".gallery-component");
        
        if(!t.hasClass("active")){
            ctn.find(".side-nav a").removeClass("active");
            t.addClass("active");
            ctn.find(".gallery-content-zone").removeClass("active");
            ctn.find(".gallery-content-zone[data-type = " + type + "]").addClass("active");
        }
        
    }
    
    //Switches Videos
    function toggleGalleryVideo(){
        var t = $(this);
        var iframe = t.attr("data-iframe");
        var ctn = t.closest(".gallery-component");
        
        if(!t.hasClass("active")){
            ctn.find(".video-nav").removeClass("active");
            t.addClass("active");
            ctn.find(".gallery-videos-frames iframe").attr("src", iframe);
        }
        
    }
    
    //Mobile Nav video
    function toggleGalleryNav(){
        var t = $(this);
        
        var ctn = t.closest(".gallery-videos-nav");
        
        ctn.toggleClass("active");
    }

    // slick on mobile
    function slick_on_mobile(slider, settings) {
        $(window).on('load resize', function () {
            if ($(window).width() > 1024) {
                if (slider.hasClass('slick-initialized')) {
                    slider.slick('unslick');
                }
                return;
            }
            if (!slider.hasClass('slick-initialized')) {
                return slider.slick(settings);
            }
        });
    }

    // Pre-initiate
    DOMInit("interactive", function (e) {
        if ($(".slick-init").length !== 0) {
            initSlick($(".slick-init"), {
                breakpoint: 1023,
                settings: {
                    arrows: false,
                    dots: true,
                    appendDots: ".slick-slider-dots"
                }
            });
        }
        
        var $slick_slider = $('.responsive-slider');
        if ($slick_slider.length !== 0) {
            var settings_slider = {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: false,
                speed: 750,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            };
            slick_on_mobile($slick_slider, settings_slider);
        }
        
        if($(".gallery-images").length !== 0) {
            $(".gallery-images").masonry({
                itemSelector: ".gallery-image",
                columnWidth: ".gallery-image",
                gutter: 20
            });
        }

        bindEvent(".category-inner-selection:not(.selected)", "click", openCategorySelection);
        bindEvent(".menu-selection-toggle-visibility", "click", toggleSelectionVisibility);

        bindEvent(".comp-img-txt-position-selector", "click", toggleCompPosition);
        
        bindEvent(".gallery-nav-btn", "click", toggleGalleryVisibility);
        bindEvent(".video-nav", "click", toggleGalleryVideo);
        bindEvent(".mobile-menu-btn", "click", toggleGalleryNav);
        
        // Generic event to toggle the component version class
        bindEvent(".component-settings-version-btn", "change", switchComponentVersion);
    });

})();